<template>
    <section class="home-container">
        <MasterPage title="饮食原则">
            <div slot="title-icon">
                <Icon type="md-analytics"/>
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="12">
                            <FormItem label="原则名称：">
                                <Input v-model="name" placeholder="请输入"/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="原则状态：">
                                <Select v-model="isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                    <Option value="false">启用</Option>
                                    <Option value="true">禁用</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true" style="margin-right: 10px">添加</Button>
                <!--<Tooltip content="下载模板文件，填写食材规则" placement="top" theme="light">-->
                <!--<Button icon="ios-cloud-download-outline" @click="uploadMouldFile">模板文件下载</Button>-->
                <!--</Tooltip>-->
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <!--            <div slot="pager">-->
            <!--                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange"-->
            <!--                      :page-size="pageSize" show-total show-elevator show-sizer/>-->
            <!--            </div>-->
        </MasterPage>
        <Modal v-model="addModel" title="新增饮食原则" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="饮食原则名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="原则描述：">
                    <Input v-model="itemAdd.description" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="编辑饮食原则" @on-cancel="cancelItem" width="700">
            <Form :label-width="100">
                <FormItem label="饮食原则名称：">
                    <Input v-model="updateInfoItem.name" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>

                <Row type='flex' justify='end'>
                    <Col span="6">
                        <Button type="dashed" long @click="onClickAddChoose()" icon="md-add">
                            新增
                        </Button>
                    </Col>
                </Row>
                <Table
                        highlight-row
                        stripe
                        :columns="columnsInfo" :data="itemInfo.detailList"
                ></Table>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">保存</Button>
            </div>
        </Modal>
        <Modal v-model="bindModel" width="750" title="绑定食材规则" @on-cancel="cancelItem">
            <Table stripe :columns="columnsList" :data="foodMaterialAllList"></Table>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading" @click="bindItem">确定</Button>
            </div>
        </Modal>
        <!--<Modal v-model="fileModel" title="文件上传，绑定食材规则" @on-cancel="cancelItem">-->
        <!--<div style="text-align: center">-->
        <!--<Upload :before-upload="fileBefore" action="" style="margin-right: 10px;margin-top: 10px">-->
        <!--<Button style="font-size: 12px" icon="ios-cloud-upload-outline">规则文件上传</Button>-->
        <!--</Upload>-->
        <!--<p style="color: #c3c3c3">上传食材规则文件，批量绑定食材规则</p>-->
        <!--</div>-->
        <!--<div slot="footer">-->
        <!--<Button type="text" size="large" @click="cancelItem">取消</Button>-->
        <!--<Button type="primary" size="large" :loading="fileLoading" @click="fileItem">确定</Button>-->
        <!--</div>-->
        <!--</Modal>-->
        <Modal v-model="infoModel" title="原则详情">
            <Form :label-width="80">
                <Row>
                    <Col span="12">
                        <FormItem label="原则名称：">
                            {{itemInfo.name}}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Table stripe :columns="columnsInfo" :data="itemInfo.detailList"></Table>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'

    export default {
        components: {
            MasterPage
        },
        data() {
            return {
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '原则名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '描述',
                        key: 'description',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth: 350,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted) {
                                return h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon: 'md-unlock',
                                        label: "small",
                                    },
                                    on: {
                                        click: () => {
                                            this.reuseItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '启用')
                            } else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon: 'md-create',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑详情'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon: 'md-trash',
                                            label: "small",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                ]);
                            }
                        }
                    }
                ],
                dataList: [],
                tableLoading: false,
                addModel: false,
                addLoading: false,
                updateModel: false,
                updateLoading: false,
                bindModel: false,
                bindLoading: false,
                fileModel: false,
                fileLoading: false,
                infoModel: false,
                columnsList: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center',
                    },
                    {
                        title: '食材名称',
                        align: 'center',
                        render: (h, params) => {
                            let item = this.foodMaterialAllList[params.index]
                            return h("span", item.name + "(" + item.unit + ")")
                        }
                    },
                    {
                        title: '禁止 允许 非常高 高 中等 低 非常低 Neg NEG 无',
                        align: 'center',
                        minWidth: 180,
                        render: (h, params) => {
                            let title = ["禁止", "允许", "非常高", "高", "中等", "低", "非常低", "Neg", "NEG", "无",]
                            let Checkbox = []
                            title.forEach(function (value) {
                                Checkbox.push(h('Checkbox', {
                                        props: {label: value},
                                        style: {marginRight: '6.5px', marginLeft: '6.5px'}
                                    }, [h('span', {style: {margin: 0}}, '')]
                                ),)
                            })
                            return h('CheckboxGroup', {
                                props: {
                                    value: this.foodMaterialAllList[params.index].dietText
                                },
                                on: {
                                    'on-change': (value) => {
                                        this.foodMaterialAllList[params.index].dietText = value.splice(-1, 1)
                                    }
                                }
                            }, Checkbox)
                        }
                    },
                    {
                        title: '备注',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                on: {
                                    "input": (value) => {
                                        this.foodMaterialAllList[params.index].remark = value
                                    }
                                }
                            })
                        }
                    },
                ],
                columnsInfo: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '可选项',
                        align: 'center',
                        render: (h, params) => {
                            return h('input', {
                                domProps: {
                                    value: params.row.name
                                },
                                on: {
                                    input: (event) => {
                                        this.itemInfo.detailList[params.index].name = event.target.value
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '分数',
                        align: 'center',
                        render: (h, params) => {
                            return h('input', {
                                domProps: {
                                    value: params.row.score
                                },
                                on: {
                                    input: (event) => {
                                        this.itemInfo.detailList[params.index].score = event.target.value
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 200,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'error',
                                    icon: 'md-trash',
                                    label: "small",
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.index)
                                    }
                                }
                            }, '删除')
                        }
                    }
                ],
                name: '',
                isDeleted: 'false',
                foodMaterialAllList: [],
                dietGuidelinesId: '',
                updateInfoItem: '',
                itemInfo: '',
                pageNum: 1,
                pageSize: 20,
                pageTotal: 0,
                itemAdd: {
                    id: '',
                    name: '',
                    description: '',
                    isDeleted: '',
                },
                file: ''
            }
        },
        created() {
            this.pageAllfoodMaterial()
            this.pageFindItem()
        },
        methods: {
            onClickAddChoose() {
                this.itemInfo.detailList.splice(this.itemInfo.detailList.length + 1, 0, {
                    id: '',
                    name: '',
                    score: ''
                });
            },
            remove(index) {
                this.itemInfo.detailList.splice(index, 1);
            },
            fileBefore(file) {
                this.file = ''
                if (file.size > 1024 * 1024 * 40) {
                    this.$Message.warning('文件大小请勿超过40M');
                    return false
                }
                this.file = file
                this.$Notice.success({title: '文件上传成功'});
                return false
            },
            pageChange(value) {
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value) {
                this.pageSize = value
                this.pageFindItem()
            },
            pageAllfoodMaterial() {
                this.$http.post('foodMaterial/list', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = msg.data.list.map((item) => {
                            item['dietText'] = [];
                            item['remark'] = '';
                            return item
                        })
                    } else {
                        this.$Notice.error({title: '食材查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem() {
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('dietGuidelines/list', {
                    name: this.name,
                    isDeleted: this.isDeleted,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data
                        this.pageTotal = msg.data.total
                    } else {
                        this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem() {
                if (this.itemAdd.name.length <= 0) {
                    return this.$Message.warning('请输入饮食原则名称');
                }
                this.addLoading = true
                this.$http.post('dietGuidelines/add', {
                    name: this.itemAdd.name,
                    description: this.itemAdd.description
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '饮食原则新增成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '饮食原则新增失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item) {
                this.updateModel = true
                this.updateInfoItem = JSON.parse(JSON.stringify(item))
                this.itemInfo = item
            },
            updateItem() {
                if (this.updateInfoItem.name.length <= 0) {
                    return this.$Message.warning('请输入饮食原则名称');
                }
                this.updateLoading = true
                this.updateInfoItem.detailList = this.itemInfo.detailList
                console.log(this.updateInfoItem)
                this.$http.post('dietGuidelines/update',
                    this.updateInfoItem,
                    {emulateJSON: false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '饮食原则修改成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '饮食原则修改失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem() {
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.bindModel = this.bindLoading = this.fileModel = this.fileLoading = this.infoModel = false
                this.itemAdd.id = this.itemAdd.name = this.itemAdd.isDeleted = ''
            },
            bindItem_modal(item) {
                this.dietGuidelinesId = item.id
                this.bindModel = true
            },
            bindItem() {
                this.bindLoading = true
                let dietInfoList = []
                this.foodMaterialAllList.forEach((item) => {
                    if (item.dietText.length > 0) {
                        dietInfoList.push({
                            text: item.dietText.toString(), textRemark: item.remark,
                            foodMaterialId: item.id, id: this.dietGuidelinesId
                        })
                        item.dietText = []
                        item.remark = ""
                    }
                })
                if (dietInfoList.length <= 0) {
                    this.cancelItem()
                    this.$Notice.error({title: '尚未选择任何食材规则'});
                    return
                }
                this.$http.post('dietGuidelines/updateInfo', {
                    dietId: this.dietGuidelinesId,
                    dietInfoList: JSON.stringify(dietInfoList),
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '原则规则绑定食材成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '原则规则绑定食材失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item) {
                this.$Modal.confirm({
                    title: '确认禁用饮食原则“' + item.name + '”',
                    loading: true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item) {
                this.$http.post('dietGuidelines/delete', {
                    id: item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '饮食原则禁用成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '饮食原则禁用失败', desc: msg.message});
                    }
                }, function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item) {
                this.$Modal.confirm({
                    title: '确认启用饮食原则“' + item.name + '”',
                    loading: true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item) {
                this.$http.post('dietGuidelines/reuse', {
                    id: item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '饮食原则启用成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '饮食原则启用失败', desc: msg.message});
                    }
                }, function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            infoItem_modal(item) {
                this.infoModel = true
                this.itemInfo = item
            },
            // uploadMouldFile(){
            //     this.$http.post('dietGuidelines/getMouldFile',
            //     ).then(function (res) {
            //         let msg = res.body
            //         if (typeof msg == 'string' || msg.success) {
            //             this.funDownload(msg,'食材原则模板文件.csv')
            //         }else {
            //             this.$Notice.error({title:'模板文件下载失败',desc: msg.message});
            //         }
            //     },function (res) {
            //         this.myError(res.body)
            //     })
            // },
            // funDownload(content, filename) {
            //     var eleLink = document.createElement('a');
            //     eleLink.download = filename;
            //     eleLink.style.display = 'none';
            //     var blob = new Blob(["\ufeff" + content]);
            //     eleLink.href = URL.createObjectURL(blob);
            //     document.body.appendChild(eleLink);
            //     eleLink.click();
            //     document.body.removeChild(eleLink);
            // },
            // fileItem(){
            //     this.fileLoading = true
            //     let fileFormData = new FormData();
            //     fileFormData.append('multipartFile',this.file, this.file.name);
            //     fileFormData.append('dietId',this.dietGuidelinesId);
            //     this.$http.post('dietGuidelines/addInfoFile',
            //         fileFormData,
            //     {emulateJSON:false}).then(function (res) {
            //         this.cancelItem()
            //         let msg = res.body
            //         if (msg.success) {
            //             this.$Notice.success({title: '文件上传成功'});
            //             this.pageFindItem()
            //         }else {
            //             this.$Notice.error({title:'文件上传失败',desc: msg.message});
            //         }
            //     },function (res) {
            //         this.cancelItem()
            //         this.myError(res.body)
            //     })
            // },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container {

    }
</style>



